'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import CustomSpinner from '@/components/CustomSpinner/CustomSpinner';
import classNames from 'classnames';
import type { PartialPageProps } from '@/types/cms/magnolia';

const SearchSuspenseFallback: FC<{ isInitialSearch?: boolean; pageProps?: PartialPageProps }> = ({
  isInitialSearch
}): JSX.Element => {
  return (
    <div
      className={classNames('search__custom-spinner', {
        search__container: isInitialSearch,
        'search-for-results': !isInitialSearch
      })}
    >
      <CustomSpinner />
    </div>
  );
};

export default SearchSuspenseFallback;
